/**
 * Owl Carousel Slider
 */

export default function HWY_Slider() {
  this.init = () => {
    createCarouselsExplore();
    createCarouselsFieldNote(true);
    jQuery(window).on("resize", function () {
      createCarouselsExplore();
      createCarouselsFieldNote(false);
    });
    createCarouselsProductDrop();
    nextSlider();
  };

  const createCarouselsExplore = () => {
    jQuery(document).ready(function ($) {
      if ($(".hwy__explore-more").length > 0) {
        $(".hwy__explore-more").each(function () {
          var el = $(this);
          if ($(this).find(".content-block-content").length === 0) {
            return;
          }
          if ($(window).width() < 800) {
            $(this)
              .find(".content-block-content")
              .addClass("owl-carousel owl-theme");
            $(this)
              .find(".content-block-content .content-block-content-item")
              .each(function () {
                $(this).addClass("item");
              });
            $(this)
              .find(".content-block-content")
              .owlCarousel({
                items: 1,
                autoWidth: false,
                nav: true,
                dots: false,
                navText: [
                  `<svg width="15" height="25" viewBox="0 0 15 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.92 0.522545C12.293 2.19973 11.8411 2.28801 9.85248 3.96519L-8.50266e-06 12.3511L8.40622 20.737C10.0332 22.4142 10.4852 22.5025 11.7507 24.1797L12.9257 23.2087L1.7174 12.3511L14.9143 1.40527L13.92 0.522545Z" fill="#8D8C7F"/>
              </svg>
              `,
                  `<svg width="15" height="25" viewBox="0 0 15 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.994471 24.1796C2.62148 22.5024 3.07344 22.4141 5.06201 20.737L14.9145 12.351L6.50827 3.9651C4.88126 2.28792 4.42929 2.19965 3.16384 0.522461L1.98877 1.49346L13.1971 12.351L0.000213623 23.2969L0.994471 24.1796Z" fill="#8D8C7F"/>
                </svg>
                  `,
                ],
              });
          } else {
            $(this).find(".content-block-content").owlCarousel("destroy");
          }
        });
      }
    });
  };
  const createCarouselsFieldNote = (trigger) => {
    jQuery(document).ready(function ($) {
      if ($(".hwy__field-notes").length > 0) {
        $(".hwy__field-notes").each(function () {
          var owl = $(this).find(".section-latest-buzz-content");
          const width = $(window).width();
          if (width >= 1024) {
            owl.owlCarousel("destroy");
            return;
          }
          owl.addClass("owl-theme owl-carousel");
          owl.owlCarousel({
            loop: false,
            nav: false,
            autoWidth: true,
            margin: 56,
            dots: false,
            responsive: {
              0: {
                center: true,
              },
              800: {
                center: false,
              },
            },
          });
          if (trigger) {
            $(this)
              .find(".slider-control .btn-prev")
              .click(function () {
                $(this)
                  .closest(".hwy__field-notes")
                  .find(".section-latest-buzz-content")
                  .trigger("prev.owl.carousel");
              });

            $(this)
              .find(".slider-control .btn-next")
              .click(function () {
                $(this)
                  .closest(".hwy__field-notes")
                  .find(".section-latest-buzz-content")
                  .trigger("next.owl.carousel");
              });
          }
        });
      }
    });
  };
  const createCarouselsProductDrop = () => {
    jQuery(document).ready(function ($) {
      if ($(".product-drop .section-products").length > 0) {
        $(".product-drop .section-products .product-item").each(function () {
          var owl = $(this).find(
            ".product-item-img .product-item-img-container"
          );
          owl.owlCarousel({
            loop: true,
            nav: false,
            dots: true,
            items: 1,
            margin: 5,
          });
        });
      }
    });
  };
  const nextSlider = () => {
    jQuery(".product-item-img-container").click(function () {
      jQuery(this).trigger("next.owl.carousel");
    });
  };
}
